import { Component, OnInit, OnDestroy } from '@angular/core';
import { EmployeeService } from '../employee/services/employee.service';
import { SharedService } from '../common/services/shared-service';
import { ActivatedRoute } from '@angular/router';
import { RoutingServiceService } from '../common/services/routing-service.service';

export const EMPLOYEE_VIEW_KEY = 'employeeView';

@Component({
    selector: 'app-employee-view',
    templateUrl: './employee-view.component.html',
    styleUrls: ['./employee-view.component.scss'],
    standalone: false
})
export class EmployeeViewComponent implements OnInit, OnDestroy {
    IsTareasHide = false;
    IsDocumentoVisible = false;
 
    constructor(
        public employeeService: EmployeeService,
        private sharedService: SharedService,
        private routingService: RoutingServiceService
    ) {}

    ngOnInit(): void {
       
        // check if there any tasks to do after a routing move
        const task =
            this.routingService.getAfterRotuingTasks(EMPLOYEE_VIEW_KEY);
        if (task) {
            this.routingService.removeRoutingMoveTask(EMPLOYEE_VIEW_KEY);
            task();
            //return;
        }
        this.checkPageRefreshCancel();
        this.sharedService.setCurrentUserPermissions();
        this.IsDocumentoVisible = this.getDocumentoVisibility();
        const EmplooyeeId = localStorage.getItem('EmplooyeeID');

        if (EmplooyeeId && EmplooyeeId !== 'null') {
            this.employeeService.getTrabajador(EmplooyeeId);
            this.employeeService.isLockedEmployee(EmplooyeeId);
            this.employeeService.InitEmployeeWarning(EmplooyeeId, 0);
        }

        this.employeeService.saveemplooye.subscribe((_res: any) => {
            this.employeeService.InitEmployeeWarning(_res, 0);
        });
        this.employeeService.selectUserData.subscribe((_res: any) => {
            this.employeeService.InitEmployeeWarning(_res, 0);
        });
        this.employeeService.selectUserappointment.subscribe((_res: any) => {
            this.employeeService.InitEmployeeWarning(_res.trabajadorId, 0);
        });
        this.employeeService.subTrabajador.subscribe((_res) => {
            this.employeeService.InitEmployeeWarning(_res.trabajadorId, 0);
        });
    }

    ngOnDestroy(): void {
        localStorage.removeItem('LeaveID');
    }

    getDocumentoVisibility(): boolean {
        return (
            this.sharedService.Permissions.HasPermisos505 &&
            (this.sharedService.Permissions.HasPermisos520 ||
                this.sharedService.Permissions.HasPermisos519)
        );
    }

    public checkPageRefresh(): void {
        if (!localStorage.getItem('page-refreshed')) {
            localStorage.setItem('page-refreshed', 'true');
            location.reload();
        } else {
            localStorage.removeItem('page-refreshed');
        }
    }
    public checkPageRefreshCancel(): void {
        if (localStorage.getItem('cancel-load')=="true") {
            localStorage.setItem('cancel-load', 'false');
            location.reload();
        } else {
            localStorage.removeItem('cancel-load');
        }
    }
}
